export default __webpack_public_path__ + "static/media/kitap3.bdfec02a.jpg";